import {
  Button,
  Checkbox,
  Label,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@barfacil/barfacil-ui'
import { ListFilter } from 'lucide-react'
import { useMemo } from 'react'

import { FilterStatus, PriceListParams } from '@/api/_schemas/management'
import { usePriceListContext } from '@/app/panel/management/price-list/_contexts/price-list-context'

type PriceListFilterStatusProps = {
  isFetching: boolean
}

export const PriceListFilterStatus = ({
  isFetching,
}: PriceListFilterStatusProps) => {
  const priceListStatus = useMemo(
    () => [
      { value: FilterStatus.Ativo, label: 'Ativo' },
      { value: FilterStatus.Inativo, label: 'Inativo' },
    ],
    [],
  )

  const { configureFilters, setConfigureFilters } = usePriceListContext()

  function handleCheckedChange(
    status: PriceListParams['status'],
    checked: boolean,
  ) {
    setConfigureFilters((previousValues) => {
      let newStatus = status

      if (previousValues.status === 'todos') {
        newStatus =
          newStatus === FilterStatus.Ativo
            ? FilterStatus.Inativo
            : FilterStatus.Ativo
      }

      if (checked) {
        newStatus = FilterStatus.Todos
      }

      return { ...previousValues, status: newStatus }
    })
  }

  return (
    <Popover modal>
      <PopoverTrigger asChild>
        <Button
          className="border border-gray-200 bg-white text-gray-300 hover:border-white hover:bg-sky-500 hover:text-white active:bg-sky-700"
          size="icon"
          variant="ghost"
        >
          <ListFilter size={24} />
        </Button>
      </PopoverTrigger>

      <PopoverContent className="flex w-80 flex-col gap-4" align="start">
        <div className="flex flex-col gap-2">
          <h3 className="font-medium">Filtrar</h3>
          <hr className="mb-4" />
        </div>

        {priceListStatus.map(({ value, label }) => (
          <div className="flex items-center space-x-2" key={label}>
            <Checkbox
              id={label}
              disabled={
                isFetching ||
                (configureFilters.status === value &&
                  configureFilters.status !== FilterStatus.Todos)
              }
              checked={[value, FilterStatus.Todos].includes(
                configureFilters.status ?? FilterStatus.Ativo,
              )}
              onCheckedChange={(checked) =>
                handleCheckedChange(value, checked as boolean)
              }
            />
            <Label className="font-normal" htmlFor={label}>
              {label}
            </Label>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  )
}
